// @ts-check
import { keys, forEach } from "lodash";

import { newLineItem, getDailyRateByFlag } from "../../util";

const setDemandGroupingsWithSupplyLineItems = ({
  groupings,
  macroAllocations,
  columnCount,
  groupTypes = {},
  canRename = false,
  isBudgetEnabled,
  groupLookup,
  hideHiddenTeams,
}) => {
  forEach(groupings, (grouping) => {
    const macroAllocationsForGrouping = macroAllocations[grouping.groupId];
    const sourceGroupIds = keys(macroAllocationsForGrouping);

    forEach(sourceGroupIds, (sourceGroupId) => {
      const group = groupLookup[sourceGroupId];
      if (!group) {
        return;
      }
      const groupType = groupTypes[group.type];
      if (hideHiddenTeams && (group.isHidden || group.isDeleted)) {
        return;
      }
      const lineItem = newLineItem({
        group,
        grouping,
        groupId: sourceGroupId,
        columnCount,
        memberCount: group.memberCount,
        canViewInDetails: true,
        canViewInTeamBuilder: true,
        canRename: canRename && groupType.canRename,
        canHide: false,
        isSupply: true,
        isSkillsMandatory: grouping.isSkillsMandatory,
        type: macroAllocationsForGrouping[sourceGroupId]?.[0]?.type,
        dailyRate: getDailyRateByFlag(
          isBudgetEnabled,
          group,
          grouping,
          groupLookup
        ),
      });
      grouping.lineItems.push(lineItem);
    });
    grouping.lineItems.sort((a, b) => a.group.name.localeCompare(b.group.name));

    setDemandGroupingsWithSupplyLineItems({
      groupings: grouping.childGroupings,
      macroAllocations,
      columnCount,
      groupTypes,
      canRename,
      isBudgetEnabled,
      groupLookup,
      hideHiddenTeams,
    });
  });
};

export default setDemandGroupingsWithSupplyLineItems;
